import { EMPTY_STATE_IMAGES } from '@Types/Constants'
import { PAGE_ENUM } from '@Types/Enums'
import { useTranslation } from 'react-i18next'

export const useContents = () => {
  const { t: translate } = useTranslation()

  return {
    [PAGE_ENUM.OVERVIEW]: {
      title: translate('Prisync.overview.emptyState.title'),
      description: translate('Prisync.overview.emptyState.description'),
      image: EMPTY_STATE_IMAGES.overviewImage,
    },
    [PAGE_ENUM.SETTINGS]: {
      title: translate('Prisync.settings.emptyState.title'),
      description: translate('Prisync.settings.emptyState.description'),
      image: EMPTY_STATE_IMAGES.settingsImage,
    },
    [PAGE_ENUM.SUBSCRIPTION]: {
      title: translate('Prisync.subscription.emptyState.title'),
      description: translate('Prisync.subscription.emptyState.description'),
      image: EMPTY_STATE_IMAGES.subscriptionImage,
    },
    // Onboarding-blocked entry for /markets — without this, the EmptyState
    // route falls back to OVERVIEW copy and shows the user the wrong page
    // context when they click Markets before finishing onboarding.
    [PAGE_ENUM.MARKETS]: {
      title: translate('Prisync.markets.emptyState.title', {
        defaultValue: 'Finish onboarding to unlock Markets',
      }),
      description: translate('Prisync.markets.emptyState.description', {
        defaultValue:
          'Markets manages multiple Shopify Markets panels under one account. Complete onboarding to start using it.',
      }),
      image: EMPTY_STATE_IMAGES.overviewImage,
    },
  }
}
